import api from '../http/api';

export default class RemoveInsuranceContractService {
  public static async execute(proposalInsuranceId: string): Promise<void> {
    await api.delete(`/proposal-insurance/${proposalInsuranceId}`);
  }
}
